// CourtSelection.js
import { Card, CardContent, Typography, Button, Grid, Box } from '@mui/material';
import Chip from '@mui/material/Chip';
// import SideAd from './SideAd';
import ImageSkeleton from './ImageSkeleton';
import { IMAGES } from "../constants";

const courts = [
  { id: 1, name: 'Futsal Court 1', description: "Entrance Futsal Court", normalPrice: 2500, peakPrice: 3000, image: IMAGES.FC1, altImage: IMAGES.img},
  { id: 2, name: 'Futsal Court 2', description: "Inner Futsal Court", normalPrice: 2500, peakPrice: 3000, image: IMAGES.FC2, altImage: IMAGES.img},
  { id: 3, name: 'Badminton Court', description: "Indoor Badminton Court", normalPrice: 700, peakPrice: 700, image: IMAGES.BAD, altImage: IMAGES.img},
  { id: 4, name: 'Leather Court 1', description: "Machine Leather Court", normalPrice: 2000, peakPrice: 2000, image: IMAGES.LC1, altImage: IMAGES.img},
  { id: 5, name: 'Leather Court 2', description: "Normal Leather Court", normalPrice: 1000, peakPrice: 1000, image: IMAGES.LC2, altImage: IMAGES.img},
];

const CourtSelection = ({ onSelectCourt }) => {
  
  const handleCourtSelect = (court) => {
    // Send court information including normal and peak prices
    onSelectCourt({
      id: court.id,
      name: court.name,
      normalPrice: court.normalPrice,
      peakPrice: court.peakPrice,
    });
  };

  return (
    <div>
      {/* <SideAd /> */}
      <Box sx={{ px: 1, textAlign: "center", mb: 2 }}>
        <Typography variant="h5" sx={{
            lineHeight: 1.3,
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
          }}
        >
          Explore Premium Courts
        </Typography>

        <Typography variant="body1" color="gray"> Select your favorite court to get started </Typography>
      </Box>
      <Grid 
        container 
        spacing={3} 
        alignItems="stretch"
      >
        {courts.map((court) => (
          <Grid 
            item 
            key={court.id} 
            xs={12} sm={6} md={4}
          >
            <Card
              className="hover:shadow-lg transition-shadow duration-300"
              sx={{
                maxWidth: 325,
                margin: '0 auto',
                boxShadow: '4px 4px 10px rgba(0, 0, 0, 0.2)',
                borderRadius: '6px',
                overflow: 'hidden',
                display: 'flex',
                flexDirection: 'column',
                "& .MuiCardContent-root": {
                    paddingBottom: 2,
                },
              }}
            >
              {/* <CardMedia
                component="img"
                height="140"
                image={court.image}
                alt={court.altImage}
                sx={{
                  width: "100%",
                  // height: 240,
                  objectFit: "cover",
                }}
              /> */}
              <div className='p-2'>
                <ImageSkeleton 
                  src={court.image} 
                  alt={court.altImage}
                  height={260}
                />
              </div>
              <CardContent sx={{ flexGrow: 1, p: '4px' }}>
                <Typography sx={{ fontSize: '1.2rem', mx: '6px', backgroundColor: '#f5f5f5', borderTopLeftRadius: 5, borderTopRightRadius: 5}}>
                  {court.name}
                </Typography>
                <Typography color="textSecondary" sx={{mx: '6px', backgroundColor: '#f5f5f5', borderBottomLeftRadius: 5, borderBottomRightRadius: 5 }}>
                  {court.description}
                </Typography>
                {court.id === 1 || court.id === 2 ? (
                  <Box sx={{ display: 'flex', flexDirection: 'column', mt: 1.5, px: '6px'}}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                      <Typography variant="body1" fontWeight="bold">
                        ⭐ Normal Hours
                      </Typography>
                      <Chip
                        label={`${court.normalPrice} LKR`}
                        sx={{ borderRadius: '8px' }}
                      />
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 1}}>
                      <Typography variant="body1" fontWeight="bold">
                        🔥 Peak Hours
                      </Typography>
                      <Chip
                        label={`${court.peakPrice} LKR`}
                        sx={{ borderRadius: '8px' }}
                      />
                    </Box>
                  </Box>
                ) : (
                  <>
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mt: 1.5, mb: 0.5, px: '8px', gap: 1, }}>
                      <Typography variant="body1" fontWeight="bold">
                        ✨ Price
                      </Typography>
                        <Chip
                            label={`${court.normalPrice} LKR`}
                            sx={{ borderRadius: '8px' }}
                        />
                    </Box>
                    <Typography variant="body2" color="textSecondary">
                      Rate for all Hours
                    </Typography>
                  </>
                )}
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => handleCourtSelect(court)}
                  sx={{ width: 'calc(100% - 10px)', mt: 2, backgroundColor: '#1f2937', '&:hover': { backgroundColor: 'gray' } }}
                >
                  Select
                </Button>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

export default CourtSelection;
